import { ApplicationElement, html } from '../application_element/element.js';
import { timeAgoInWords } from '../../lib/time_helpers.js';

import translations from './translations.js';

const ONE_HOUR = 60 * 60 * 1000;
const STALE_DAYS = 60 * 60 * 24 * 7 * 1000; // 7 days

/**
 * Display time ago
 *
 * @prop timestamp - Start time in timestamp
 * @prop dateTime - Start date time
 * @prop class - Css class to style element
 * @prop locale - Localization
 */
export default class Timeago extends ApplicationElement {
  static properties = {
    timeago: { type: String, attribute: false },
    timestamp: { type: Date },
    live: { type: Boolean },
  };

  /** @internal */
  static translations = translations;

  constructor() {
    super();
    this.live = true;
  }

  firstUpdated() {
    super.firstUpdated();

    this.updateTimeAgo();
    this.shouldTick() && this.tick();
  }

  shouldTick() {
    return this.live && this.isFresh;
  }

  get isFresh() {
    return new Date() - this.timestamp < ONE_HOUR;
  }

  get isStale() {
    return new Date() - this.timestamp > STALE_DAYS;
  }

  get isCurrentYear() {
    return this.timestamp.getFullYear() === new Date().getFullYear();
  }

  get staleDate() {
    return this.i18n.l(
      `time.formats.${this.isCurrentYear ? 'short' : 'long2'}`,
      this.timestamp
    );
  }

  tick() {
    this.updateTimeAgo();
    this.ticker = setTimeout(() => this.tick(), 5000);
  }

  stop() {
    clearTimeout(this.ticker);
  }

  updateTimeAgo() {
    this.timeago = this.getTimeago();
  }

  getTimeago() {
    return this.timestamp && timeAgoInWords(this.timestamp, true, true);
  }

  render() {
    if (!this.timestamp) return null;

    return html`${this.isStale
      ? this.staleDate
      : this.t('format', { time: this.timeago })}`;
  }
}

Timeago.registerTagName('ef-timeago');

customElements.get('ef-timeago') ||
  customElements.define('ef-timeago', Timeago);
